export default __webpack_public_path__ + "static/media/audio_47_serrucho.12f85b60.mp3";